import { useSpring, animated } from 'react-spring';
import { useState, useLayoutEffect, useRef } from 'react';

interface CollapsableSectionProps {
    expanded: boolean;
    children: React.ReactNode;
}

export function CollapsableSection({ expanded, children }: CollapsableSectionProps) {
    const contentRef = useRef<HTMLDivElement>(null);
    const [contentHeight, setContentHeight] = useState(0);

    useLayoutEffect(() => {
        if (contentRef.current) {
            const contentElement = contentRef.current;
            const heightWithMargin =
                contentElement.scrollHeight +
                parseInt(window.getComputedStyle(contentElement).marginTop || '0', 10) +
                parseInt(window.getComputedStyle(contentElement).marginBottom || '0', 10);

            setContentHeight(heightWithMargin);
        }
    }, [children]);

    const styles = useSpring({
        height: expanded ? contentHeight : 0,
        opacity: expanded ? 1 : 0,
        config: { tension: 250, friction: 30 },
    });

    return (
        <animated.div
            style={{
                ...styles,
                overflow: 'hidden',
            }}
        >
            <div
                ref={contentRef}
                style={{
                    visibility: expanded ? 'visible' : 'hidden'
                }}
            >
                {children}
            </div>
        </animated.div>
    );
}
